import { NavLink } from "react-router-dom";

const NavList = ({ toToggle, from }) => {
  const onNavigate = () => {
    if (from === "header") {
      toToggle();
    }
  };
  return (
    <>
      <a
        href="https://amplicondxlab.com/index.php"
        className="elements"
        target="_self"
        rel="noopener noreferrer"
      >
        Home
      </a>
      <a
        href="https://amplicondxlab.com/about-amplicon-dx-lab.php"
        className="elements"
        target="_self"
        rel="noopener noreferrer"
      >
        About
      </a>
      <a
        href="https://amplicondxlab.foxibe.dev/"
        className="elements"
        target="_self"
        rel="noopener noreferrer"
      >
        Career
      </a>
      <a
        href="https://amplicondxlab.com/page-contact.php"
        className="elements"
        target="_self"
        rel="noopener noreferrer"
      >
        Contact
      </a>

      {/* <NavLink
        activeClassName="active_link"
        onClick={onNavigate}
        to="/aboutUs"
        className="elements pushLeft bg-gray "
      >
        About Us
      </NavLink> */}
      {/* <NavLink
        activeClassName="active_link"
        onClick={onNavigate}
        to="/contactUs"
        className="elements"
      >
        (405)866-5100 &nbsp; | &nbsp; Contact Us
      </NavLink> */}
    </>
  );
};

export default NavList;
